import React, { Component } from "react";
import { Row, Modal } from "antd";
import { groupBy, map } from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
  GrantsPaymentContent,
  AddressContainer,
  DataContainer,
  DataHeading,
  AdvisorContainer,
  FirstColumn,
  SecondColumn,
  ModalButtonContainer,
  CancelButton,
  HorizontalDivider,
  InfoContent,
  GrantContent,
  GrantContentItalic,
  DataContainerLetter,
  GrantsPaymentContentPurposeBased,
  GrantsPaymentContentCC,
  AdvisorWrapper,
  AdditionalCommentSpan,
  LetterMainRow,
} from "./style";
import {GeneralButton} from '../../../../../../CommonComponents/Commons/commonComponents';
import autorizedSignature from "../../../../../../assets/images/jane_signature.jpg";
import { removeDuplicates } from "../../../../../../utils/commonUtil";
import formatter from "../../../../../../utils/formatter";
import { paymentLetterDerivedStates } from '../../Selectors/PaymentLetterSelectors';
export class GrantPaymentLetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryAdvisor: [],
    };
  }

  componentWillReceiveProps() {
    const { primaryAdvisor } = this.props.grantData;

    let consolidateAddresses = groupBy(primaryAdvisor, (data) => {
      return (
        data.addressLine1 ||
        "" + data.addressLine2 ||
        "" + data.addressLine3 ||
        "" + data.city ||
        "" + data.zipCode ||
        ""
      ).toLowerCase();
    });

    const resultData = map(consolidateAddresses, (value, key) => {
      let combinedName = "";
      value.forEach((advisor, i) => {
        combinedName += (i === 0 ? "</p>" : ",") + "<p>" + advisor.name;
      });
      let addressData = value.length && value[0];
      return { combinedName, ...addressData };
    });

    this.setState({ primaryAdvisor: resultData || [] });
  }

  renderAddressInfo = () => {
    const { primaryAdvisor } = this.state;
    if (primaryAdvisor && primaryAdvisor.length) {
      return primaryAdvisor.map((value, index) => {
        return (
          <AdvisorContainer key={value.combinedName}>
            {
              <div
                dangerouslySetInnerHTML={{ __html: value.combinedName }}
              ></div>
            }
            {value.addressLine1}
            {value.addressLine1 && (
              <span>
                ,<br />
              </span>
            )}
            {value.addressLine2} {value.addressLine3}{" "}
            {(value.addressLine2 || value.addressLine3) && (
              <span>
                ,<br />
              </span>
            )}
            {value.city}
            {value.city && <span>,</span>} {value.state}, {value.zipCode}
          </AdvisorContainer>
        );
      });
    } else {
      return <GrantsPaymentContent>TBD</GrantsPaymentContent>;
    }
  };
  render() {
    const {
      name,
      addressLine1,
      addressLine2,
      addressLine3,
      city,
      state,
      zipCode,
    } = this.props.grantData.granteeOrg;
    const { purpose } = this.props.grantData;
    return (
      <Modal
        width="75%"
        visible={this.props.visible}
        onCancel={this.props.onCancel}
        footer={[
          <ModalButtonContainer>
            <GeneralButton type = 'functional' inverted={true} width= '150px' onClick={this.props.onCancel} text = "Close"></GeneralButton>
          </ModalButtonContainer>,
        ]}
      >
        <p>
          <div>
            <div className="agreementPreviewOverlay">
              <LetterMainRow>
                <AddressContainer>
                  {name || ""}
                  <br />
                  {addressLine1 || ""}
                  {addressLine1 && <br />}
                  {addressLine2 || ""}
                  {addressLine2 && <br />}
                  {addressLine3 || ""}
                  {addressLine3 && <br />}
                  {`${city ? `${city},` : ""} ${state || ""} ${zipCode || ""}`}
                  {!name && !addressLine1 && !addressLine2 ? "TBD" : ""}
                </AddressContainer>

                {/* <GrantsPaymentContent>
                                    {this.props.grantData.dateofPayment ? moment(this.props.grantData.dateofPayment).format('MMMM D, YYYY') : 'TBD'}
                                </GrantsPaymentContent> */}

                <GrantsPaymentContent>
                  To a representative at {name ? " " + name : "TBD"}:
                </GrantsPaymentContent>
                <GrantsPaymentContent>
                  I am pleased to attach a grant to {name} from Vanguard
                  Charitable, a 501(c)(3) nonprofit organization that
                  administers a donor-advised fund. This grant was issued at the
                  recommendation of one of our donors.
                </GrantsPaymentContent>
                <DataContainer>
                  {/* 6159 - 'anonymous donor' shows based on Grant Recognition, not based on Permission to publish value.*/}
                  A grant from{" "}
                  {this.props.grantData.grantRecognition.grantRecognition ===
                  "GAA" ? (
                    <span>anonymous donor</span>
                  ) : (
                    <span>{this.props.grantData.grantFrom}</span>
                  )}
                </DataContainer>
                <DataContainer>
                  In the amount of{" "}
                  {" " + this.props.grantData.grantAmount > 0 ? (
                    <>
                      {formatter({
                        value: this.props.grantData.grantAmount,
                        fieldSuffix: "Dollars",
                      })}
                    </>
                  ) : (
                    "TBD"
                  )}
                </DataContainer>
                <span>
                  <DataContainerLetter>
                    {(this.props.grantData.grantAmount < 5000 ||
                      this.props.grantData.grantAmount === 5000) &&
                    purpose.purpose !== "Class gift" &&
                    purpose.purpose !== "Scholarship fund" &&
                    purpose.purpose !== "Scholarship" &&
                    purpose.purpose !== "Missionary support" ? (
                      <span>
                        Under your full control and discretion, this grant is
                        intended to support:{" "}
                      </span>
                    ) : purpose.purpose === "Missionary support" ? (
                      <>
                        <span> To be used for: </span>{" "}
                        {`Under your full control and discretion, this gift is intended 
                                                            to provide support for ${this.props.missionaryName}'s participation in missionary work in 
                                                            ${this.props.missionaryLocation}:`}
                      </>
                    ) : purpose.purpose === "Scholarship" ? (
                      <>
                        <span> To be used for: </span>
                        {`Under your full control and discretion, this gift is intended 
                                                                    to provide support for a scholarship${
                                                                      purpose.additionalComments ? (
                                                                        <AdditionalCommentSpan>{`: ${purpose.additionalComments}`}</AdditionalCommentSpan>
                                                                      ) : (
                                                                        ""
                                                                      )
                                                                    }`}
                      </>
                    ) : (
                      <span> To be used for: </span>
                    )}
                    {purpose.description === "Specific project"
                      ? this.props.grantData.projectName
                        ? this.props.grantData.projectName || "TBD"
                        : this.props.project || "TBD"
                      : ""}
                    {purpose.additionalComments &&
                    purpose.description === "Specific project" ? (
                      <AdditionalCommentSpan>{`: ${purpose.additionalComments}`}</AdditionalCommentSpan>
                    ) : (
                      ""
                    )}
                    {purpose.description === "Underwriting cost of event"
                      ? this.props.grantData.eventName
                        ? `Underwriting cost of ${this.props.grantData.eventName}`
                        : `Underwriting cost of ${this.props.event}`
                      : ""}
                    {purpose.additionalComments &&
                    purpose.description === "Underwriting cost of event" ? (
                      <AdditionalCommentSpan>{`: ${purpose.additionalComments}`}</AdditionalCommentSpan>
                    ) : (
                      ""
                    )}
                    {purpose.description === "Missionary support" ? (
                      purpose.additionalComments ? (
                        <AdditionalCommentSpan>
                          {purpose.additionalComments}
                        </AdditionalCommentSpan>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {purpose.description === "Other" ? (
                      purpose.additionalComments ? (
                        <AdditionalCommentSpan>
                          {purpose.additionalComments}
                        </AdditionalCommentSpan>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {purpose.description !== "Specific project" &&
                    purpose.description !== "Underwriting cost of event" &&
                    purpose.purpose !== "Missionary support" &&
                    purpose.purpose !== "Scholarship" &&
                    purpose.purpose !== "Other" ? (
                      <>
                        {purpose.description ? purpose.description : "TBD"}
                        {purpose.additionalComments ? (
                          <AdditionalCommentSpan>{`: ${purpose.additionalComments}`}</AdditionalCommentSpan>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </DataContainerLetter>
                </span>
                {this.props.grantData.grantRecognition.inMemoryOfName && (
                  <DataContainerLetter>
                    <span>In memory of: </span>
                    {" " +
                      (this.props.grantData.grantRecognition.inMemoryOfName
                        ? this.props.grantData.grantRecognition.inMemoryOfName
                        : "")}
                  </DataContainerLetter>
                )}
                {this.props.grantData.grantRecognition.inHonorOfName && (
                  <DataContainerLetter>
                    <span>In honor of: </span>
                    {" " +
                      (this.props.grantData.grantRecognition.inHonorOfName
                        ? this.props.grantData.grantRecognition.inHonorOfName
                        : "")}
                  </DataContainerLetter>
                )}
                {(this.props.grantData.grantRecognition.notifyFirstName ||
                  this.props.grantData.grantRecognition.notifyLastName) && (
                  <DataContainerLetter>
                    <span>Please notify: </span>
                    {" " +
                      this.props.grantData.grantRecognition.notifyFirstName +
                      " " +
                      this.props.grantData.grantRecognition.notifyLastName}
                  </DataContainerLetter>
                )}

                {(purpose.purpose === "Non-legally binding pledge/commitment" ||
                  purpose.purpose === "Class gift" ||
                  purpose.purpose === "Fundraising event" ||
                  purpose.purpose === "Fundraising support" ||
                  purpose.purpose === "Underwriting cost of event") && (
                  <GrantsPaymentContentPurposeBased>
                    Grants from Vanguard Charitable are for the public good and
                    may not be used to confer cash, goods, or services
                    ("Prohibited Benefits") to any person with advisory
                    privileges to the recommending account at Vanguard
                    Charitable, or their family members or controlled entities
                    ("Disqualified Persons"). Such grants also may not be used
                    to pay any legal obligation that a Disqualified Person owes
                    to a charity, including any legally binding pledge to make a
                    gift.By accepting this grant, you agree that it will not
                    confer any Prohibited Benefit to any Disqualified Person or
                    pay any Disqualified Person's pledge or other legal
                    obligation.
                  </GrantsPaymentContentPurposeBased>
                )}

                {(purpose.purpose === "Scholarship fund" ||
                  purpose.purpose === "Scholarship") && (
                  <GrantsPaymentContentPurposeBased>
                    Vanguard Charitable makes grants to organizations, not to
                    individuals. By accepting this grant, you agree that this
                    grant is under your organization's full control and
                    discretion, including any funds that you may utilize to
                    support the named scholarship fund. You further represent
                    that there is no agreement, written or oral, that allows any
                    person with advisory privileges to the recommending account
                    at Vanguard Charitable to select the scholarship recipient
                    or any agreement that designates or restricts the
                    individuals eligible for scholarships to members of such
                    person's family.
                  </GrantsPaymentContentPurposeBased>
                )}

                {purpose.purpose === "Missionary support" && (
                  <GrantsPaymentContentPurposeBased>
                    Vanguard Charitable makes grants to organizations, not to
                    individuals. By accepting this grant, you agree that this
                    grant is under your organization's full control and
                    discretion, including any funds that you may utilize to
                    support the missionary work conducted by the named
                    individual(s) above. By accepting this grant, you agree that
                    any individual named in reference to the grant is or will be
                    performing missionary services on your behalf, in
                    furtherance of your mission.
                  </GrantsPaymentContentPurposeBased>
                )}

                {this.props.grantData.grantRecognition.grantRecognition ===
                  "GAN" && (
                  <GrantsPaymentContent>
                    At its discretion, your organization may thank the donors
                    named in this letter. However, no individual or entity
                    should receive a tax substantiation letter from your
                    organization in connection with this grant.
                  </GrantsPaymentContent>
                )}
                {/* 6159 - This sentences should be show only if user select anonymous as recognition type. Do not depend on permission to publish checkbox */}
                {this.props.grantData.grantRecognition.grantRecognition ===
                  "GAA" && (
                  <GrantsPaymentContent>
                    The recommending donor wishes to remain anonymous. Vanguard
                    Charitable is unable to provide your organization with any
                    identifying information.
                  </GrantsPaymentContent>
                )}
                {(this.props.grantData.grantRecognition.grantRecognition ===
                  "GAA" ||
                  !this.props.grantData.publishPermission) && (
                  <GrantsPaymentContent>
                    At the request of the recommending donor, do not publish any
                    identifying or contact information contained in this grant
                    letter in your newsletters, web pages, reports, or other
                    materials.
                  </GrantsPaymentContent>
                )}
                {this.props.grantData.grantRecognition.grantRecognition ===
                  "GAO" && (
                  <GrantsPaymentContent>
                    <span>Recognizing who recommended the grant:</span>The
                    recommending donor requested that only the account name is
                    included in this letter. The donor does not wish to provide
                    personal contact information.
                  </GrantsPaymentContent>
                )}
                {/* 6159 - 'Advisors Addresses' shows based on Grant Recognition, not based on Permission to publish value.*/}
                {this.props.grantData.grantRecognition.grantRecognition ===
                  "GAN" && (
                  <DataHeading>
                    Please recognize these individuals or entities for this
                    grant:
                  </DataHeading>
                )}
                {this.props.grantData.grantRecognition.grantRecognition ===
                  "GAN" && (
                  <AdvisorWrapper>
                    {!this.props.grantData.hideAdvisorInfo &&
                      this.renderAddressInfo()}
                    <AdvisorContainer>
                      {this.props.grantData.thirdPartyDetails}
                    </AdvisorContainer>
                  </AdvisorWrapper>
                )}
                <GrantsPaymentContent>
                  By accepting this grant, your organization agrees (a) to use
                  the grant exclusively in furtherance of your organization’s
                  tax-exempt mission, (b) that the grant will not confer a
                  prohibited benefit to the recommending donor, his or her
                  family members, or certain entities that they own or control,
                  and (c) to abide by the additional certifications, policies,
                  and guidelines contained in the{" "}
                  <span>Important information about grants</span> section on the
                  following pages. If your organization is uncertain whether you
                  can certify the accuracy of any of these statements, please
                  contact Vanguard Charitable at 888-383-4483.
                </GrantsPaymentContent>
                <GrantsPaymentContent>
                  We are pleased to support your organization and its mission on
                  behalf of our donors. More information is available at
                  vanguardcharitable.org/nonprofits.
                </GrantsPaymentContent>
                <br />
                <GrantsPaymentContent>Best regards,</GrantsPaymentContent>
                <br />
                <GrantsPaymentContent>
                  Vanguard Charitable
                </GrantsPaymentContent>
                <br />
                {/* 6159 - Hide CC when user select "Third Party" recognition type and and clicks the "Do not include
                                account advisor information on the letter" checkbox */}
                {this.props.grantData.grantRecognition.grantRecognition ===
                  "GAN" &&
                  !this.props.grantData.hideAdvisorInfo && (
                    <span>
                      {this.props.grantData.primaryAdvisor.map(
                        (value, index) => {
                          return (
                            <GrantsPaymentContentCC key={value.name}>
                              cc: {value.name}
                            </GrantsPaymentContentCC>
                          );
                        }
                      )}
                    </span>
                  )}
                <AddressContainer></AddressContainer>
              </LetterMainRow>
            </div>

            <HorizontalDivider />

            <Row>
              <FirstColumn lg={11} sm={12} xs={24}>
                <InfoContent>
                  Important information about grants from Vanguard Charitable
                </InfoContent>
                {this.props.grantData.grantAmount > 1 &&
                  (this.props.grantData.grantAmount < 5000 ||
                    this.props.grantData.grantAmount === 5000) && (
                    <InfoContent>
                      This grant is not restricted for a specific purpose and by
                      accepting this grant on behalf of your organization you
                      agree that this grant is under your organization’s full
                      control and discretion, including any funds that you may
                      in your discretion apply to the recommended purpose
                      contained in the payment letter, provided that such
                      recommended purpose is consistent with the terms below
                      regarding grants from Vanguard Charitable.
                    </InfoContent>
                  )}
                <InfoContent>Prohibited benefits</InfoContent>
                <GrantContent>
                  Grants from Vanguard Charitable are to be used for charitable
                  and other tax-exempt purposes. Such grants may not be used to
                  confer a Prohibited Benefit to any Disqualified Person. A
                  Disqualified Person includes the recommending donor, his or
                  her family members, and certain entities that they own or
                  control.
                </GrantContent>
                <GrantContent>
                  A Prohibited Benefit is any benefit that is more than
                  incidental and would have the effect of reducing the amount
                  that a recommending donor could otherwise deduct as a
                  charitable contribution if the recommending donor had made the
                  donation directly from personal funds. Prohibited Benefits may
                  include cash, goods, or services received as a result of a
                  distribution from a donor-advised fund. Illustrative examples
                  include, but are not limited to, tickets, vouchers, or
                  admission to performances, sporting events, or other events;
                  items purchased at charitable auctions; payment of club dues,
                  school tuition, and legally binding obligations.
                </GrantContent>
                <GrantContentItalic>
                  By accepting a grant from Vanguard Charitable, you certify
                  that the grant will not confer a Prohibited Benefit to any
                  Disqualified Persons.
                </GrantContentItalic>
                <InfoContent>
                  No bifurcation to acquire prohibited benefits
                </InfoContent>
                <GrantContent>
                  Grants from Vanguard Charitable may not be used to enable a
                  Disqualified Person to purchase a Prohibited Benefit with
                  personal funds if such Prohibited Benefit would not have been
                  available for purchase but for the grant.
                </GrantContent>
                <GrantContentItalic>
                  By accepting a grant from Vanguard Charitable, you certify
                  that the grant will not be used to enable a Disqualified
                  Person to purchase an otherwise Prohibited Benefit using
                  personal funds.
                </GrantContentItalic>
                <InfoContent>Pledges and other legal obligations</InfoContent>
                <GrantContent>
                  Grants from Vanguard Charitable may not be used to pay any
                  legal obligation that a Disqualified Person owes to a charity.
                  A legally binding pledge to make a gift is an example of such
                  an obligation. If you are not sure whether a Disqualified
                  Person has entered into a legally binding contract to make a
                  gift, please contact Vanguard Charitable.
                </GrantContent>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that the grant will not be used to pay any legally binding
                  pledge or other legal obligation that a Disqualified Person
                  owes to your organization. You further agree that this payment
                  letter does not bind the donor or Vanguard Charitable to any
                  future payments to your organization.
                </GrantContentItalic>
              </FirstColumn>
              <SecondColumn lg={11} sm={11} xs={24}>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that your organization is recognized as exempt under Section
                  501(c)(3) and classified as a public charity other than a
                  disqualified supporting organization (defined below).
                </GrantContentItalic>
                <InfoContent>Disqualified supporting organizations</InfoContent>
                <GrantContent>
                  Vanguard Charitable may not make grants to disqualified
                  supporting organizations, including (a) non-functionally
                  integrated Type III supporting organizations, and (b)
                  supporting organizations that in turn support organizations
                  that Disqualified Persons directly or indirectly control.
                </GrantContent>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that you are not a disqualified supporting organization.
                </GrantContentItalic>
                <InfoContent>No additional charitable deduction</InfoContent>
                <GrantContent>
                  Donors should have already claimed a charitable contribution
                  deduction when they made a gift to Vanguard Charitable. No
                  additional deduction is permitted when Vanguard Charitable
                  makes grants to other organizations. Accordingly, you should
                  not send a charitable contribution tax deduction
                  substantiation letter to any individual, organization, or
                  entity in connection with this grant.
                </GrantContent>
                <InfoContent>No lobbying purpose</InfoContent>
                <GrantContent>
                  Grants from Vanguard Charitable generally may not be used to
                  support lobbying. Prohibited lobbying includes direct or
                  grassroots lobbying communications that reflect a view of
                  support or opposition on a specific legislative proposal. If
                  you are uncertain whether an activity is prohibited lobbying,
                  please contact Vanguard Charitable.
                </GrantContent>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that none of the grant funds will be used for direct or
                  grassroots lobbying.
                </GrantContentItalic>
                <InfoContent>
                  Scholarships, missionary support grants, and other grants to
                  individuals
                </InfoContent>
                <GrantContent>
                  Vanguard Charitable makes grants to other organizations, not
                  to individuals. If your organization intends to use this grant
                  to award scholarships or grants to individuals, you must (a)
                  maintain discretion and control over the grant funds from
                  Vanguard Charitable, (b) not award any scholarship to a
                  Disqualified Person (including family members of any
                  donor-advisor), and (c) not allow any Disqualified Person to
                  select grant recipients.
                </GrantContent>
                <GrantContent>
                  Any individuals recommended in connection with this grant are
                  for your consideration only. This grant does not legally
                  obligate you to award any scholarship or grant to any
                  individual.
                </GrantContent>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that your organization (a) will maintain discretion and
                  control over the grant funds, (b) will not award any
                  scholarship or grant to a Disqualified Person (including
                  family members of any donor-advisor), and (c) has not and will
                  not enter into any agreement, oral or written,
                </GrantContentItalic>
              </SecondColumn>
            </Row>

            <HorizontalDivider />

            <Row>
              <FirstColumn lg={11} sm={11} xs={24}>
                <GrantContentItalic>
                  whereby any Disqualified Person may cause the selection of any
                  secondary grantee who is an individual.
                </GrantContentItalic>
                <InfoContent>Grant recognition</InfoContent>
                <GrantContent>
                  The attached grant is from a donor-advised fund sponsored by
                  Vanguard Charitable. It is not a gift directly from the
                  recommending donor or account advisor’s personal funds.
                  Accordingly, any public statements acknowledging the grant
                  should credit Vanguard Charitable as the source of the funds.
                  Such statements may acknowledge the account named in the
                  attached letter as the source of the grant recommendation
                  unless otherwise specified on page one of this letter.
                </GrantContent>
                <InfoContent>Private non-operating foundations</InfoContent>
                <GrantContent>
                  Grants from Vanguard Charitable should not be made for the
                  purpose of enabling an organization that is controlled by a
                  Disqualified Person to avoid classification as a private
                  non-operating foundation.
                </GrantContent>
                <GrantContent>
                  A private non-operating foundation is a charitable
                  organization that is not a public charity and does not operate
                  its own tax-exempt programs. Private non-operating foundations
                  are subject to special tax rules.
                </GrantContent>
                <GrantContentItalic>
                  By accepting this grant, you certify (a) that your
                  organization is not controlled by Disqualified Persons and (b)
                  that it would not be classified a private non-operating
                  foundation without the support it has received from Vanguard
                  Charitable, including this grant.
                </GrantContentItalic>
                <InfoContent>Fiscal sponsors</InfoContent>
                <GrantContent>
                  Vanguard Charitable generally makes grants to organizations
                  that the IRS has determined to be tax-exempt public charities.
                  Some organizations that have not yet received IRS recognition
                  of tax-exempt status raise funds through fiscal sponsorship
                  arrangements with a recognized public charity. Vanguard
                  Charitable makes grants to fiscal sponsors, provided that the
                  fiscal sponsor maintains discretion and control over the
                  funds.
                </GrantContent>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that your organization maintains discretion and control over
                  any grant funds used to support the fiscal sponsorship of
                  another organization.
                </GrantContentItalic>
                <InfoContent>U.S. Office of Foreign Assets Control</InfoContent>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that all grant funds will be used in compliance with all
                  statutes, Executive Orders, and regulations restricting or
                  prohibiting U.S. persons from engaging in transactions and
                  dealings with countries, entities, and individuals subject to
                  economic sanctions administered by the U.S. Department of the
                  Treasury’s Office of Foreign Assets Control (OFAC), including
                  the OFAC Specially Designated Nationals (SDN) list.
                </GrantContentItalic>
                <GrantContentItalic>
                  For more information, visit www.treasury.gov.
                </GrantContentItalic>
              </FirstColumn>
              <SecondColumn lg={11} sm={11} xs={24}>
                <InfoContent>Foreign projects and organizations</InfoContent>
                <GrantContent>
                  Vanguard Charitable makes grants to U.S. public charities with
                  a recommended purpose of distributing any portion of the funds
                  to a foreign organization only to the extent that the grantee
                  exercises complete control and discretion regarding the use of
                  the grant and with the understanding that the grantee may
                  redirect the grant to other projects in support of its
                  mission.
                </GrantContent>
                <GrantContentItalic>
                  By accepting this grant from Vanguard Charitable, you certify
                  that your organization maintains control and discretion over
                  the grant funds used to support a foreign project or
                  organization.
                </GrantContentItalic>
                <InfoContent>Additional information</InfoContent>
                <GrantContent>
                  Please refer to Vanguard Charitable’s Policies and guidelines
                  booklet at www.vanguardcharitable.org/policies for more
                  information on our granting review and distribution policies.
                  If you have questions or concerns, please be sure to contact
                  Vanguard Charitable as soon as possible.
                </GrantContent>
                <InfoContent>
                  Your organization is responsible for contacting Vanguard
                  Charitable at 888-383-4483 if there are updates to the
                  following: address or contact information used for purposes of
                  mailing grants to your organization, tax-exempt status, or any
                  other relevant changes.
                </InfoContent>
                <GrantContent>
                  Vanguard Charitable was founded by The Vanguard Group, Inc.
                  ("Vanguard"), as an independent, nonprofit, public charity in
                  1997. Although Vanguard provides certain investment management
                  and administrative services to Vanguard Charitable pursuant to
                  a service agreement, Vanguard Charitable is not a program or
                  activity of Vanguard. A majority of Vanguard Charitable’s
                  Trustees are independent of Vanguard.
                </GrantContent>
              </SecondColumn>
            </Row>
            <HorizontalDivider />
          </div>
        </p>
      </Modal>
    );
  }
}

GrantPaymentLetter.propTypes = {
  event: PropTypes.string,
  grantData: PropTypes.object,
  missionaryLocation: PropTypes.string,
  missionaryName: PropTypes.string,
  onCancel: PropTypes.func,
  project: PropTypes.string,
  visible: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  ...paymentLetterDerivedStates(state.toJS())
});

export default withRouter(connect(mapStateToProps, null)(GrantPaymentLetter));
